import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var updateProfileSlice = createSlice({
    name: "updateProfile",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            state.isFetching = false;
            state.data = action.payload;
            state.isError = false;
        },
        fetchDataFailure: function(state) {
            state.isFetching = false;
            state.isError = true;
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _updateProfileSlice_actions = updateProfileSlice.actions;
export var fetchData = _updateProfileSlice_actions.fetchData, fetchDataSuccess = _updateProfileSlice_actions.fetchDataSuccess, fetchDataFailure = _updateProfileSlice_actions.fetchDataFailure, resetState = _updateProfileSlice_actions.resetState;
export default updateProfileSlice.reducer;
